/**
 * Parses a CSV / edit-cell value into a string list.
 * Accepts JSON arrays (`["a","b"]`) or pipe-separated values (`a|b`).
 */
export function parseStringList(value: unknown): string[] {
  if (value == null) return [];
  if (Array.isArray(value)) {
    return value
      .map(String)
      .map((s) => s.trim())
      .filter(Boolean);
  }
  const raw = String(value).trim();
  if (!raw) return [];
  if (raw.startsWith('[')) {
    try {
      const parsed: unknown = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        return parsed
          .map(String)
          .map((s) => s.trim())
          .filter(Boolean);
      }
    } catch {
      // fall through to pipe / comma split
    }
  }
  return raw
    .split(/[|,]/)
    .map((s) => s.trim())
    .filter(Boolean);
}

export function serializeStringList(value: unknown): string {
  return JSON.stringify(parseStringList(value));
}
